import type { DayOfWeek } from "@/shared/enums/DayOfWeekEnum"

export class PostCompanyOrderPeriodRequestEntity {
  id?: number | null
  time?: string
  timeDayOfWeek?: DayOfWeek
  dayOfWeek?: DayOfWeek
}